import { Helmet } from "react-helmet-async";
import PageTitle from '../../components/pageTitle/PageTitle';
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useEffect, useState } from "react";
import axiosRequest from "../../services/axios/axiosRequest";
import Loading from "../../components/loading/Loading";
import styles from './protocolDetails.module.css';
import { Button } from "@mui/material";
import { IoArrowForward } from "react-icons/io5";
import DOMPurify from 'dompurify';


export default function ProtocolDetails() {

  const navigateTo = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [protocol, setProtocol] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const protocolController = new AbortController();
    axiosRequest.get(`/protocols/${slug}/`, { signal: protocolController.signal })
      .then(res => setProtocol(res.data))
      .catch(err => { if (err.status === 404 && err.response?.data?.detail === "Not found.") navigateTo('/notFound') })
      .finally(() => setIsLoading(false));
    return () => protocolController.abort();
  }, []);

  return (
    <>
      <Helmet>
        {isLoading ?
          <>
            <title>پروتکل - نوآوران پژوه</title>
            <meta name='description' content="پروتکل های شرکت نوآوران پژوه" />
          </>
          :
          <>
            <title>{`پروتکل ${protocol?.title} - نوآوران پژوه`}</title>
            <meta name='description' content={`${protocol?.description?.substring(0, 150)}`} />
          </>
        }
      </Helmet>

      <Header />

      <main className={`${styles.container} mainContainer container-lg`}>
        <Button className='d-flex gap-1 mb-4' variant='outlined' onClick={() => navigateTo('/protocols')}>
          <IoArrowForward />
          <span className='d-none d-sm-block'>سایر پروتکل ها</span>
        </Button>
        {isLoading ? <Loading /> :
          <article>
            {protocol &&
              <>
                <PageTitle className={styles.title} title={`پروتکل ${protocol.title}`} views={protocol.views} />
                <section className={styles.articleBody} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(protocol.description)}}></section>
              </>
            }
          </article>
        }
      </main>

      <Footer />
    </>
  )
}
